import { END_POINTS } from '../constants/urls';
import emptySplitApi from '../utils/rtk';

interface CommonResponseType {
    statusCode: number;
    message: string;
}

export const promotionsApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        addPromotion: builder.mutation<CommonResponseType & { data?: any }, any>({
            query: (body) => ({
                url: END_POINTS.promotions,
                method: 'POST',
                body,
            }),
        }),
        updatePromotion: builder.mutation<
            CommonResponseType & { data?: any },
            { body: any }
        >({
            query: ({ body }) => ({
                url: `${END_POINTS.promotions}`,
                method: 'PUT',
                body,
            }),
        }),
        getPromotionList: builder.query<
            CommonResponseType & {
                data: {
                    RewardPromotions: any[];
                    count: number;
                };
            },
            {
                page: number;
                limit: number;
                type: number;
                status?: string;
                sort?: string;
                search?: string;
                dateFrom?: string;
                dateTo?: string;
            }
        >({
            query: ({ page, limit, search, status, type, dateFrom, dateTo, sort }) => ({
                url: `${END_POINTS.promotions}/list/?type=${type}&page=${page}&limit=${limit}${search ? `&search=${search}` : ''}${status !== 'default' ? `&isActive=${status === '1' ? true : false}` : ''}${dateFrom ? `&dateFrom=${dateFrom}` : ''}${dateTo ? `&dateTo=${dateTo}` : ''}${sort ? `&sortBy=createdAt&sortOrder=${sort}` : ''}`,
                method: 'GET',
            }),
        }),
        getPromotionById: builder.query<
            CommonResponseType & { data: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.promotions}/${id}`,
                method: 'GET',
            }),
        }),
        getPromotionReactionsById: builder.query<
            CommonResponseType & { data: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.listReactions}/${id}`,
                method: 'GET',
            }),
        }),
        deletePromotion: builder.mutation<
            CommonResponseType & { data?: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.promotions}/${id}`,
                method: 'DELETE',
                body: {},
            }),
        }),
    }),
});

export const {
    useAddPromotionMutation,
    useUpdatePromotionMutation,
    useLazyGetPromotionListQuery,
    useGetPromotionByIdQuery,
    useLazyGetPromotionByIdQuery,
    useDeletePromotionMutation,
    useGetPromotionReactionsByIdQuery,
} = promotionsApi;
